<template>
    <b-card>
        <ContentOrLoading style="min-height: 200px;">
            <b-row v-if="! loading">
                <b-col cols=12>
                    <h3>Total de abonados agrupados por sección y precio.</h3>
                    <b-table striped hover :items="ocupacionSectoresPrecios" responsive/>
                </b-col>       
            </b-row>
        </ContentOrLoading>
    </b-card>  
</template>

<script>
    export default {
        props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
        data() {
            return {
                loading: true,
                ocupacionSectoresPrecios: null
            }
        },
        created() {
            this.getInformeOcupacionSectoresPrecios();
        },
        methods: {
            getInformeOcupacionSectoresPrecios() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_id: this.lista_id
                };

                if (this.fecha_inicio && this.fecha_fin) {
                    params.filters.fecha_inicio = this.fecha_inicio;
                    params.filters.fecha_fin = this.fecha_fin;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.desglose-ventas.ocupacion-sectores-precios'), params).then(res => {
                    this.ocupacionSectoresPrecios = res.data.data;
                }).finally(() => this.loading = false);
            }
        }
    }
</script>